import {
  ScheduleNeededBannerIcon,
  ScheduleNeededBannerRoot,
  ScheduleNeededBannerText,
} from './styles';

// Figma node 36197:19622 — outline warning icon, GravyWork 2.0 Baseline.
// Original vector: 19.5x19.5 @ stroke 1.5px, centered inside a 24x24 frame.
const WarningIcon = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <g transform="translate(2.25 2.25)">
      <path
        d="M9.75 6.75V10.5M18.75 9.75C18.75 14.7206 14.7206 18.75 9.75 18.75C4.77944 18.75 0.75 14.7206 0.75 9.75C0.75 4.77944 4.77944 0.75 9.75 0.75C14.7206 0.75 18.75 4.77944 18.75 9.75ZM9.75 13.5H9.7575V13.5075H9.75V13.5Z"
        stroke="#BB8700"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

type ScheduleNeededBannerProps = {
  jobsWithoutShifts: number;
};

const ScheduleNeededBanner = ({
  jobsWithoutShifts,
}: ScheduleNeededBannerProps) => {
  if (jobsWithoutShifts <= 0) return null;

  const subject =
    jobsWithoutShifts === 1
      ? '1 skill still needs a schedule'
      : `${jobsWithoutShifts} skills still need a schedule`;
  const message = `${subject} — add a schedule now or remove it from this order.`;

  return (
    <ScheduleNeededBannerRoot role="alert" aria-label={message}>
      <ScheduleNeededBannerIcon>
        <WarningIcon />
      </ScheduleNeededBannerIcon>
      <ScheduleNeededBannerText>{message}</ScheduleNeededBannerText>
    </ScheduleNeededBannerRoot>
  );
};

export default ScheduleNeededBanner;
